import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  EmployeeContractFullModel,
  EmployeeContractModel,
  EmployeeContractResourceService,
  EmployeeType,
  PagedEmployeeContractFullModel,
  SaveEmployeeContractRequest,
} from '../vn-api';
import { PagedList } from '../interface';

@Injectable({
  providedIn: 'root'
})
export class HxEmployeeContractService {
  constructor(
    private employeeContractApi: EmployeeContractResourceService,
  ) {
  }

  getEmployeeContracts(params?: {
    limit?: number;
    page?: number;
    storeId?: number;
    userId?: number;
    type?: EmployeeType;
    includeDisabled?: boolean;
  }): Promise<PagedList<EmployeeContractFullModel>> {
    return firstValueFrom(this.employeeContractApi.getAllEmployeeContracts(
      params?.includeDisabled,
      params?.limit,
      params?.page,
      params?.storeId,
      params?.type,
      params?.userId,
    )) as Promise<PagedEmployeeContractFullModel>;
  }

  getEmployeeContractById(id: number): Promise<EmployeeContractModel> {
    return firstValueFrom(this.employeeContractApi.getEmployeeContractById(id));
  }

  saveEmployeeContract(body: Partial<SaveEmployeeContractRequest>): Promise<EmployeeContractModel> {
    return firstValueFrom(this.employeeContractApi.saveEmployeeContract(body as SaveEmployeeContractRequest));
  }

  deleteEmployeeContractById(id: number): Promise<EmployeeContractModel> {
    return firstValueFrom(this.employeeContractApi.removeEmployeeContractById(id));
  }
}
